import type { BasicBooking } from "../../common/graphql/fragments/gql/BasicBooking";
import { transformToUpdateBookingFormState } from "../../common/update-information/utils/transformToUpdateBookingFormState";
import {
  initializeUpdateForm,
  multiInitializeUpdateForm,
} from "./updateFormActions";
import { formIdVariants, type UpdateFormIdVariant } from "./updateFormReducer";

export const initializeUpdateFormWithBooking = (
  booking: BasicBooking,
  formId: UpdateFormIdVariant,
) =>
  initializeUpdateForm(
    { bookingNo: booking.bookingNo, formId },
    transformToUpdateBookingFormState(booking, {
      canBeEmpty: formId === "Details",
    }),
    booking,
  );

export const initializeAllUpdateFormsWithBooking = (booking: BasicBooking) =>
  formIdVariants.map((formId) =>
    initializeUpdateForm(
      { bookingNo: booking.bookingNo, formId },
      transformToUpdateBookingFormState(booking, {
        canBeEmpty: formId === "Details",
      }),
      booking,
    ),
  );

export const multiInitializeUpdateFormWithBookings = (
  bookings: BasicBooking[],
  formId: UpdateFormIdVariant,
) =>
  multiInitializeUpdateForm(
    formId,
    bookings.map((basicBooking) => ({
      booking: basicBooking,
      formState: transformToUpdateBookingFormState(basicBooking),
    })),
  );
